// useDocumentOverflowControl.tsx
import { useEffect } from "react"

/**
 * Manages the document body overflow based on a given condition.
 * @param {boolean} isOpen - Boolean indicating if the modal or any component is open.
 */
export const useDocumentOverflowControl = (isOpen: boolean) => {
    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : ""

        // Clean-up function to ensure that overflow is reset when the component unmounts
        return () => {
            document.body.style.overflow = ""
        }
    }, [isOpen]) // Dependency on isOpen ensures that changes in its state will correctly update the overflow.
}
